import { format } from 'owa-localize';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { isNullOrWhiteSpace } from 'owa-string-utils';

/**
 * Calculates the picture url for a place
 * @param viewState: the persona control state, contains the information about the place
 * @param width: The width of the map
 * @param height: The height of the map
 */
export default function calculatePhotoUrl(
    latitude: number | undefined,
    longitude: number | undefined,
    width: number,
    height: number
): string {
    let userConfiguration = getUserConfiguration();
    let baseUrl = '';
    let key = '';
    let culture = '';

    // get the values of the baseUrl, key and culture directly from the userConfiguration
    if (
        userConfiguration != null &&
        userConfiguration.ApplicationSettings != null &&
        userConfiguration.SessionSettings != null &&
        userConfiguration.PolicySettings != null &&
        userConfiguration.PolicySettings.PlacesEnabled
    ) {
        baseUrl = userConfiguration.ApplicationSettings.StaticMapUrl;
        key = userConfiguration.ApplicationSettings.MapControlKey;
        culture = userConfiguration.SessionSettings.UserCulture;
    }

    // if baseUrl, key, culture, latitude and longitude available then construnct the Url
    if (
        !isNullOrWhiteSpace(baseUrl) &&
        !isNullOrWhiteSpace(key) &&
        !isNullOrWhiteSpace(culture) &&
        latitude &&
        longitude
    ) {
        return format(
            baseUrl + '?centerPoint={0},{1}&pp={0},{1};51&ms={2},{3}&fmt=png&key={4}&c={5}',
            latitude,
            longitude,
            width,
            height,
            key,
            culture
        );
    }

    return '';
}
